/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: K
 * @LastEditTime: 2022-09-19 17:41:57
 */
import { Col } from 'antd'
import React, { useEffect, useState } from 'react'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import styles from './ReplaceMakeSupplier.module.css'
import { ReplaceMakeSupplier } from './ReplaceMakeSupplier'
import { Supplier } from './supplier'
import { HerbsDirectory } from './herbsDirectory'
import { useLocation } from 'react-router-dom'

export const ReplaceCenter = () => {
  const location: any = useLocation()

  const [selectedTab, setSelectedTab] = useState('1')

  const storageParams = JSON.parse(sessionStorage.getItem(location.pathname) || '{}')

  useEffect(() => {
    setSelectedTab(location?.state?.station || storageParams.state)
  }, [location?.state])

  return (
    <Col className={styles.container}>
      <TabBar
        activeKey={selectedTab}
        destroyInactiveTabPane
        onChange={(v) => {
          setSelectedTab(v)
        }}
      >
        <TabPane key='1' tab='代煎饮片厂'>
          <ReplaceMakeSupplier state={selectedTab} />
        </TabPane>
        <TabPane key='2' tab='代煎供应商'>
          <Supplier state={selectedTab} />
        </TabPane>
        <TabPane key='3' tab='代煎药材目录'>
          <HerbsDirectory state={selectedTab} /> 
        </TabPane>

      </TabBar>
    </Col>
  )
}
